module.exports = __webpack_public_path__ + "img/check-filled.d297131a.svg";